/**
 * Dates for a Persian reader.
 *
 * Uses the Persian (Jalali) calendar via Intl, not a Gregorian date with Persian
 * digits: "۲۱ اوت ۲۰۲۶" is the right numerals attached to the wrong calendar,
 * and it reads as a translation artefact. `fa-IR-u-ca-persian` is a LOCALE tag,
 * not a country reference on the page; nothing it produces names Iran.
 *
 * Falls back to the raw ISO date if Intl lacks the calendar, which is possible
 * on a minimal Node build.
 */
export function faDate(iso: string): string {
  try {
    return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso.slice(0, 10);
  }
}
